import styled from "styled-components";

export const ActiveContent = styled.div`
  display: flex;
  flex: flex-column;
  align-items: center;
  margin: auto;
  width: 25rem;
  height: 35rem;
  border-radius: 4px;
  padding: 1.5rem 2rem;
  background: var(--black-200) !important;
  border: none !important;
`;

export const ActiveOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75) !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  label {
    text-align: left;
  }

  h2 {
    width: 18.3125rem;
    text-align: center;
  }

  p {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: center;
    color: var(--grey-100);
    margin-bottom: 2rem;
  }

  select {
    margin-bottom: 2rem;
  }

  input {
    margin-bottom: 2rem;
  }

  .select-container {
    width: 100%;
  }
`;

export const Title = styled.h2`
  margin-bottom: 2rem;
`;

export const ActiveConfirmButton = styled.button`
  width: 10.8125rem;
  height: 3rem;
  background: var(--primary);
  border-radius: 0.25rem;
  color: var(--black-100);
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1rem;

  &:disabled {
    background: var(--grey-200);
    color: var(--grey-300);
    cursor: default;
  }
`;
